
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./sdk-router.cjs.production.min.js')
} else {
  module.exports = require('./sdk-router.cjs.development.js')
}
